import React from 'react';
import './styles.scss';

export default function ThreeDotsLoader() {
  return <div className="dot-flashing" />;
}
